import firebase from 'firebase/app'
  
  var firebaseConfig = {
    apiKey: "AIzaSyA0r-42wNtIGwwUAhcCgxLFefmSBfpFpBg",
    authDomain: "car-appointment-fsqahl.firebaseapp.com",
    databaseURL: "https://car-appointment-fsqahl.firebaseio.com",
    projectId: "car-appointment-fsqahl",
    storageBucket: "car-appointment-fsqahl.appspot.com",
    messagingSenderId: "1005414428637",
    appId: "1:1005414428637:web:5078b148a8a99bfcc51034"
    // measurementId: "G-0G9KJ52GJ7"
  };
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);
 

  // firebase.analytics();

  export default firebase;